/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
// Component: -uu8Ke8fb9WQ
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonNav from "../../ButtonNav"; // plasmic-import: I5mpCJ_vE7Ya/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectcss
import sty from "./PlasmicFooter.module.css"; // plasmic-import: -uu8Ke8fb9WQ/css
import image34IviVlzpNzXsC from "./images/image34.svg"; // plasmic-import: iviVlzpNzXsC/picture

createPlasmicElementProxy;

export const PlasmicFooter__VariantProps = new Array("layout");

export const PlasmicFooter__ArgProps = new Array("sectionId");

const $$ = {};

function PlasmicFooter__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layout",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.layout
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <section
      data-plasmic-name={"footer"}
      data-plasmic-override={overrides.footer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_cGVJnrZBpZGCmuty7FxDYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.footer,
        {
          [sty.footerlayout_full]: hasVariant($state, "layout", "full"),
          [sty.footerlayout_withOffset]: hasVariant(
            $state,
            "layout",
            "withOffset"
          )
        }
      )}
      id={(() => {
        try {
          return $props.sectionId;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      <div
        data-plasmic-name={"contentWrapper2"}
        data-plasmic-override={overrides.contentWrapper2}
        className={classNames("all", sty.contentWrapper2)}
      >
        <div
          data-plasmic-name={"leftColumn2"}
          data-plasmic-override={overrides.leftColumn2}
          className={classNames("all", sty.leftColumn2)}
        >
          <div className={classNames("all", sty.freeBox__vXdMh)}>
            <div className={classNames("all", sty.freeBox__nk53R)}>
              <div className={classNames("all", "__wab_text", sty.text__jmPmm)}>
                {"o21p"}
              </div>
              <div
                className={classNames("all", "__wab_text", sty.text___3N4HA)}
              >
                {"/"}
              </div>
              <ButtonNav
                data-plasmic-name={"buttonNav"}
                data-plasmic-override={overrides.buttonNav}
                className={classNames("__wab_instance", sty.buttonNav, {
                  [sty.buttonNavlayout_withOffset]: hasVariant(
                    $state,
                    "layout",
                    "withOffset"
                  )
                })}
                color={"white"}
                iconForButton={
                  <PlasmicImg__
                    data-plasmic-name={"img"}
                    data-plasmic-override={overrides.img}
                    alt={""}
                    className={classNames(sty.img, {
                      [sty.imglayout_withOffset]: hasVariant(
                        $state,
                        "layout",
                        "withOffset"
                      )
                    })}
                    displayHeight={"100%"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"none"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"100%"}
                    loading={"lazy"}
                    src={{
                      src: image34IviVlzpNzXsC,
                      fullWidth: 20,
                      fullHeight: 20,
                      aspectRatio: undefined
                    }}
                  />
                }
                onClick={async () => {
                  const $steps = {};
                  $steps["goToHttpsO21PCom"] = true
                    ? (() => {
                        const actionArgs = { destination: "https://o21p.com/" };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToHttpsO21PCom"] != null &&
                    typeof $steps["goToHttpsO21PCom"] === "object" &&
                    typeof $steps["goToHttpsO21PCom"].then === "function"
                  ) {
                    $steps["goToHttpsO21PCom"] =
                      await $steps["goToHttpsO21PCom"];
                  }
                }}
                shape={"globalRounding"}
                status={"normal"}
              />
            </div>
            <div className={classNames("all", "__wab_text", sty.text__way5N)}>
              {
                "\u00a92025 o21p - all rights reserved.\nBuilt and backed by haaaven, SRL."
              }
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"rightColumn2"}
          data-plasmic-override={overrides.rightColumn2}
          className={classNames("all", sty.rightColumn2)}
        >
          <div className={classNames("all", sty.freeBox__pbrpg)}>
            <div className={classNames("all", "__wab_text", sty.text__oT6Do)}>
              {"COMPANY."}
            </div>
            <div className={classNames("all", "__wab_text", sty.text__cuvBo)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__xjj4H,
                      {
                        [sty.linklayout_full__xjj4HumPeH]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://team.o21p.com/cause"}
                    platform={"react"}
                  >
                    {"cause"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__u8Xtm)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__qyl2V,
                      {
                        [sty.linklayout_full__qyl2VumPeH]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://partner.o21p.com/mission"}
                    platform={"react"}
                  >
                    {"mission"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__iugpO)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__pxLh7
                    )}
                    href={"https://opformypractice.com/legal"}
                    platform={"react"}
                  >
                    {"legal"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <div className={classNames("all", sty.freeBox___6Mr0N)}>
            <div className={classNames("all", "__wab_text", sty.text__sky2H)}>
              {"WEBSITES."}
            </div>
            <div className={classNames("all", "__wab_text", sty.text__jSg3N)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__tjBtv,
                      {
                        [sty.linklayout_full__tjBtVumPeH]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://partner.o21p.com/"}
                    platform={"react"}
                  >
                    {"partner"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__rrqKq)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__gfcSc,
                      {
                        [sty.linklayout_full__gfcSCumPeH]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://team.o21p.com/"}
                    platform={"react"}
                  >
                    {"team"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__nmWfo)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__bGueZ,
                      {
                        [sty.linklayout_full__bGueZumPeH]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://nexus.o21p.com/"}
                    platform={"react"}
                  >
                    {"nexus"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__xwten)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link___2N5VT
                    )}
                    href={"https://opformypractice.com/legal"}
                    platform={"react"}
                  >
                    {"legal"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <div className={classNames("all", sty.freeBox___4S76P)}>
            <div className={classNames("all", "__wab_text", sty.text__asp3C)}>
              {"CONTACT."}
            </div>
            <div className={classNames("all", "__wab_text", sty.text__elYl4)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__p6Iw,
                      {
                        [sty.linklayout_full__p6IWumPeH]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        ),
                        [sty.linklayout_withOffset__p6IWaBDnK]: hasVariant(
                          $state,
                          "layout",
                          "withOffset"
                        )
                      }
                    )}
                    href={"https://o21p.com/support"}
                    platform={"react"}
                  >
                    {"support"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames("all", "__wab_text", sty.text___4Bpt, {
                [sty.textlayout_full___4BptumPeH]: hasVariant(
                  $state,
                  "layout",
                  "full"
                )
              })}
            >
              {"cristian@o21p.com"}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const PlasmicDescendants = {
  footer: [
    "footer",
    "contentWrapper2",
    "leftColumn2",
    "buttonNav",
    "img",
    "rightColumn2"
  ],

  contentWrapper2: [
    "contentWrapper2",
    "leftColumn2",
    "buttonNav",
    "img",
    "rightColumn2"
  ],

  leftColumn2: ["leftColumn2", "buttonNav", "img"],
  buttonNav: ["buttonNav", "img"],
  img: ["img"],
  rightColumn2: ["rightColumn2"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFooter__ArgProps,
          internalVariantPropNames: PlasmicFooter__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFooter__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "footer") {
    func.displayName = "PlasmicFooter";
  } else {
    func.displayName = `PlasmicFooter.${nodeName}`;
  }
  return func;
}

export const PlasmicFooter = Object.assign(
  // Top-level PlasmicFooter renders the root element
  makeNodeComponent("footer"),
  {
    // Helper components rendering sub-elements
    contentWrapper2: makeNodeComponent("contentWrapper2"),
    leftColumn2: makeNodeComponent("leftColumn2"),
    buttonNav: makeNodeComponent("buttonNav"),
    img: makeNodeComponent("img"),
    rightColumn2: makeNodeComponent("rightColumn2"),
    // Metadata about props expected for PlasmicFooter
    internalVariantProps: PlasmicFooter__VariantProps,
    internalArgProps: PlasmicFooter__ArgProps
  }
);

export default PlasmicFooter;
/* prettier-ignore-end */
